import { createFileRoute } from "@tanstack/react-router";
import { contactVerificationStatusRoute } from "@/app-clients/viewer-identity-flow";

export const Route = createFileRoute(
    "/api/kits/contact-verifications/$challengeId",
)({
    ...contactVerificationStatusRoute,
});
